import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid gap-2" }
const _hoisted_2 = { class: "grid gap-1" }

import { ref } from 'vue'
  import {cn, toast} from '@/utils/utils'
  import { Button } from "@/components/ui/button";
  import SigninService from "@/services/signin/signin.service";
  import {useRoute} from "vue-router";
  import router from "@/router";
  import PasswordInput from "@/components/ui_custom/input/PasswordInput.vue";
  import {toTypedSchema} from "@vee-validate/zod";
  import * as z from "zod";
  import {useForm} from "vee-validate";
  import {FormControl, FormField, FormItem, FormMessage} from "@/components/ui/form";
  import {i18n} from "@/utils/i18n";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPasswordForm',
  setup(__props) {

  const isLoading = ref(false);
  const route = useRoute();
  const formSchema = toTypedSchema(z.object({
    password: z.string(),
    confirmPassword: z.string(),
  })
      .refine((data) => data.password === data.confirmPassword , { message: i18n.global.t('validations.sameAsPassword'), path: ['confirmPassword'] })
  )
  const { handleSubmit } = useForm({
    validationSchema: formSchema,
  })

  const onSubmit = handleSubmit(async (values) => {
    const res = await SigninService.resetPassword(values.password, route.params.email as string, route.params.token as string);
    if (res?.data.statusCode === 200) {
      isLoading.value = false;
      await router.push({name: 'signin'});
      toast.success(res.data.message);
    } else {
      toast.error(res?.data.message);
    }
    isLoading.value = false;

    setTimeout(() => {
      isLoading.value = false
    }, 3000)
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(cn)('grid gap-6'))
  }, [
    _createElementVNode("form", {
      onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(FormField), { name: "password" }, {
            default: _withCtx(({ componentField }) => [
              _createVNode(_unref(FormItem), { class: "w-full" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(FormControl), null, {
                    default: _withCtx(() => [
                      _createVNode(PasswordInput, _mergeProps({
                        placeholder: _ctx.$t('column.password')
                      }, componentField, { "auto-correct": "off" }), null, 16, ["placeholder"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_unref(FormMessage))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }),
          _createVNode(_unref(FormField), { name: "confirmPassword" }, {
            default: _withCtx(({ componentField }) => [
              _createVNode(_unref(FormItem), { class: "w-full" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(FormControl), null, {
                    default: _withCtx(() => [
                      _createVNode(PasswordInput, _mergeProps({
                        placeholder: _ctx.$t('column.confirm_password')
                      }, componentField, { "auto-correct": "off" }), null, 16, ["placeholder"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_unref(FormMessage))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ]),
        _createVNode(_unref(Button), { disabled: isLoading.value }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('login.reset_password')), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ], 32)
  ], 2))
}
}

})